import { render, staticRenderFns } from "./EdmsIdToDocument.vue?vue&type=template&id=36591072&scoped=true&"
import script from "./EdmsIdToDocument.vue?vue&type=script&lang=js&"
export * from "./EdmsIdToDocument.vue?vue&type=script&lang=js&"
import style0 from "./EdmsIdToDocument.vue?vue&type=style&index=0&id=36591072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36591072",
  null
  
)

export default component.exports